import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import template from './mainButtonSet.vue';

@Component({
    mixins: [template],
})
export default class MainButtonSet extends Vue {
    @Prop({ default: 'Continue' })
    rightBtnText: string;

    @Prop({ default: 'Cancel' })
    leftBtnText: string;

    @Prop({ default: '' })
    rightBtnStyle: string; // custom css style

    @Prop({ default: '' })
    leftBtnStyle: string;

    // @Prop()
    // rightBtnAction: Function;

    // @Prop()
    // leftBtnAction: Function;

    rightBtnAction() {
        this.$emit('rightBtnAction');
    }

    leftBtnAction() {
        this.$emit('leftBtnAction');
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./src/components/mainButtonSet/index.ts